import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export const inputCls =
    "w-full rounded-xl border border-white/10 bg-[#052536] px-4 py-2.5 text-sm text-[#F2F5F6] placeholder-[#697B80] outline-none transition-colors duration-200 focus:border-[#22A6C0]";

export const labelCls = "mb-1.5 block text-xs font-bold uppercase tracking-[0.14em] text-[#A3B3B8]";

export const btnPrimary =
    "inline-flex items-center justify-center gap-2 rounded-full bg-[#22A6C0] px-5 py-2.5 text-sm font-bold text-[#052536] transition-colors duration-200 hover:bg-[#4CC9DC] disabled:cursor-not-allowed disabled:opacity-50";

export const btnGhost =
    "inline-flex items-center justify-center gap-2 rounded-full border border-white/15 px-4 py-2 text-xs font-bold text-[#A3B3B8] transition-colors duration-200 hover:border-[#4CC9DC] hover:text-[#F2F5F6]";

export const btnDanger =
    "inline-flex items-center justify-center gap-2 rounded-full border border-red-400/30 px-4 py-2 text-xs font-bold text-red-300 transition-colors duration-200 hover:border-red-400 hover:text-red-200";

export const STATUS_LABELS = { new: "Νέο", read: "Διαβάστηκε", replied: "Απαντήθηκε" };
export const STATUS_STYLES = {
    new: "border-[#F7EAB8]/40 bg-[#F7EAB8]/10 text-[#F7EAB8]",
    read: "border-[#4CC9DC]/40 bg-[#4CC9DC]/10 text-[#4CC9DC]",
    replied: "border-[#5FBBAC]/40 bg-[#5FBBAC]/10 text-[#5FBBAC]",
};

export const CATEGORY_LABELS = { article: "Άρθρα", news: "Νέα TheraOffice", instagram: "Instagram / Facebook", guide: "Οδηγοί" };

export const Badge = ({ children, className = "", testId }) => (
    <span
        data-testid={testId}
        className={`inline-flex w-fit items-center rounded-full border px-2.5 py-0.5 text-[11px] font-bold ${className}`}
    >
        {children}
    </span>
);

export const StatusBadge = ({ status }) => (
    <Badge testId={`status-badge-${status}`} className={STATUS_STYLES[status] || STATUS_STYLES.new}>
        {STATUS_LABELS[status] || status}
    </Badge>
);

export const Spinner = ({ testId = "admin-spinner" }) => (
    <div className="flex min-h-[40vh] items-center justify-center" data-testid={testId}>
        <Loader2 className="animate-spin text-[#4CC9DC]" size={32} />
    </div>
);

export const ConfirmButton = ({ onConfirm, label, confirmLabel = "Σίγουρα;", className = btnDanger, testId }) => {
    const [armed, setArmed] = useState(false);
    useEffect(() => {
        if (!armed) return;
        const t = setTimeout(() => setArmed(false), 3000);
        return () => clearTimeout(t);
    }, [armed]);
    return (
        <button
            type="button"
            data-testid={testId}
            onClick={() => (armed ? onConfirm() : setArmed(true))}
            className={`${className} ${armed ? "border-red-400 bg-red-400/10 text-red-200" : ""}`}
        >
            {armed ? confirmLabel : label}
        </button>
    );
};

export const fmtDateTime = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    return d.toLocaleDateString("el-GR", { day: "numeric", month: "short", year: "numeric" }) +
        " · " +
        d.toLocaleTimeString("el-GR", { hour: "2-digit", minute: "2-digit" });
};

export const fmtDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("el-GR", { day: "numeric", month: "short", year: "numeric" });
};
